/**
 * Production hard-stop for the mock-auth bypass.
 *
 * `VITE_MOCK_AUTH=true` swaps the real Azure AD B2C sign-in for a `MockAuthProvider`
 * that grants a synthetic user with no login. That is a legitimate local-dev convenience,
 * but a production bundle must never ship with it enabled — a single bad `--build-arg`
 * would otherwise disable authentication entirely.
 *
 * This is intentionally a pure function (booleans in, throw or return) so it is trivially
 * unit-testable without having to stub Vite's statically-replaced `import.meta.env`.
 * Callers pass `import.meta.env.PROD` and `environment.mockAuth`.
 */
export function assertMockAuthNotInProduction(isProd: boolean, mockAuth: boolean): void {
  if (isProd && mockAuth) {
    throw new Error(
      'Refusing to boot: VITE_MOCK_AUTH=true in a production build. ' +
        'Mock auth bypasses Azure AD B2C sign-in and must never be enabled in production. ' +
        'Rebuild with VITE_MOCK_AUTH=false.'
    )
  }
}
